import React, { useEffect, useState } from 'react';
import { requestForOTP, verifyOTP } from '../api';
import { useLocation, useNavigate } from 'react-router-dom';

import { Box } from '@mui/material';
import { LOGIN_BG } from '../Login';
import MobileLoginBG from '../../../Assets/Svg/login/login-mobile-bg.svg';
import Verify from '../common/Verify';
import { handleError } from '../util';
import { makeStyles } from '@mui/styles';
import routes from '../../../Constants/routes';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    backgroundImage: `url(${LOGIN_BG})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    [theme.breakpoints.down('sm')]: {
      backgroundImage: `url(${MobileLoginBG})`,
    },
  },
}));
export default function VerifyNumber() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { state: navigateState } = useLocation();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (!navigateState?.id) {
      navigate(routes.signup);
    }
  }, [navigate, navigateState?.id]);

  const onSubmit = async ({ otp: { otp } }) => {
    setLoading(true);
    try {
      const res = await verifyOTP({
        otp,
        id: navigateState.phone,
      });

      if (!res?.success) {
        alert(res?.errorMessage || 'something went wrong');
        return;
      }

      await requestForOTP({ id: navigateState.email });
      navigate(routes.verifyEmail, {
        state: {
          id: navigateState.alumniId,
          email: navigateState.email,
          phone: navigateState.phone,
        },
      });
    } catch (error) {
      handleError(enqueueSnackbar, error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className={classes.container}>
      <form>
        <Verify
          loading={loading}
          from="verifyNumber"
          title="Verify Your Number"
          subTitle={
            <>
              <span>
                Please entre the OTP sent on your registered mobile number
              </span>
              <strong style={{ marginLeft: '5px' }}>
                *******{navigateState.phone.slice(-3)}.
              </strong>
            </>
          }
          submitText="Verify & Sign Up"
          onVerify={(otp) => {
            onSubmit({ otp });
          }}
          resendOTP={async () => {
            await requestForOTP({ id: navigateState.phone });
          }}
        ></Verify>
      </form>
    </Box>
  );
}
